import { createNS } from "@ontologies/core";

const wdt = createNS("http://www.wikidata.org/prop/direct/");

export default {
  ns: wdt,
};
